import { render, staticRenderFns } from "./Lightbox.vue?vue&type=template&id=51826aae"
import script from "./Lightbox.vue?vue&type=script&lang=ts"
export * from "./Lightbox.vue?vue&type=script&lang=ts"
import style0 from "./Lightbox.vue?vue&type=style&index=0&id=51826aae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports